<template>
  <div class="modal_window" v-if="show">
    <div class="shadow_background" @click="$emit('close')"></div>
    <div class="modal_window__content">
      <div class="close_icon" @click="$emit('close')"><img src="@/assets/img/white-circle-close.svg" /></div>
      <p class="window_title">{{ title }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-window',

  props: {
    'title': String,
    'show': Boolean
  },

}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/home.sass"
</style>